<template>
  <wrap-container>
    <help-title title="Reponer / Inhabilitar tarjeta" />

    <help-list-container>
      <help-list-item tituloLista="Robo/Reponer">
        Para denunciar el robo o extravío de tus tarjetas comunicate a los
        siguientes números: <br />
        <strong>Tarjeta de Débito</strong> <br />
        - Centro de Atención Banelco: (011) 4320-2500 <br />
        - Si estás en el exterior:
        <ol>
          Estados Unidos y Canadá: 1-0800-396-9665 (sin cargo).<br />
          Para Resto del Mundo: (303) 967- 1098 (por cobro revertido).
        </ol>
        <br />
        <strong>Tarjeta de Crédito Visa</strong> <br />
        - Centro de Denuncias Visa: (011) 4379-3333 o 0810-666-3368 para el
        interior del país. <br />
        - Desde el exterior:
        <ol>
          Estados Unidos: 1877-233-8472101-6985
          <br />
          Resto del mundo: 1 (303) 967-1098 (por cobro revertido).
        </ol>
        <br />
        <strong>Tarjeta de Crédito MasterCard</strong> <br />
        - Centro de Atención Telefónica a Socios: 4340-5700 o 0810-999-5700 para
        el interior del país. <br />
        - Desde el exterior: (5411) 4340-5656, por cobro revertido.
      </help-list-item>

      <help-list-item tituloLista="Reimpresion">
        Para solicitar la reimpresión de tu Tarjeta de crédito ingresá a Banca
        online con DNI, usuario y clave digital y seleccioná: <br />
        <strong
          >Tarjetas ➜ Mis Tarjetas y hacé click sobre la que necesites ➜
          Operaciones ➜ Solicitar Reimpresión de Tarjeta.</strong
        ><br />
        <br />
        <strong>Tarjeta de Debito</strong><br />
        Para solicitar la reimpresión de tu Visa Débito, ingresá a Banca Online
        con DNI, Usuario y Clave Digital, seleccioná la opción<br />
        <strong
          >Tarjetas ➜ Visa débito ➜ Voy a ➜ Operaciones ➜ Pedir
          Reposición.</strong
        >
        <br />
        <br />
        También podes hacer tu pedido en Línea BBVA: 0800-333-0303 de lunes a
        viernes de 07:30 a 21:00 hs . Identificate con documento y Clave BBVA.
        Si no podes generarla por ambos medios acercate a la Sucursal con tu
        DNI. Tené presente que la reimpresión tiene costo. <br />
        <br />
        Para mayor información
        <a
          id="contactForm"
          href="https://www.bbva.com.ar/personas/tabla-de-comisiones.html"
          >ingresá aquí</a
        >
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
